export default "__VITE_ASSET__D5tnwbVw__"